export default {
  queriedLabels:[]
}
